import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AdminProductsPage.css'
import * as actionTypes from '../../../store/actions';
import AdminAuth from '../../../services/AdminAuth';
import * as actionCreators from '../../../store/actionCreators';

export class AdminProductsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ip4_gaig: true,
            ip5mva_gaig: true,
            ip7_gaig: true,
            ip5_gaig: false,
            ia_gaig: false,
            iaadvisory_gaig: false,
            ip4_raymond_james: false,
            ip5mva_raymond_james: false,
            ip7_raymond_james: true,
            ip5_raymond_james: false,
            ia_raymond_james: false,
            iaadvisory_raymond_james: false,
            ip4_wells_fargo: false,
            ip5mva_wells_fargo: false,
            ip7_wells_fargo: false,
            ip5_wells_fargo: true,
            ia_wells_fargo: false,
            iaadvisory_wells_fargo: false,
            ip4_mmfa: false,
            ip5mva_mmfa: false,
            ip7_mmfa: false,
            ip5_mmfa: false,
            ia_mmfa: false,
            iaadvisory_mmfa: false,
            submitted: false,
            adminConfigurationValidateFailed: false
        }

        this.props.adminPageSetSaved(false);
        this.props.getAdminProductsConfiguration();

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        this.props.setAdminPage();
        if (this.props.updateMenuState) {
            this.props.updateMenuState();
        }
        if (AdminAuth.isAdminAuthenticated()) {
            this.props.adminSuccessfullyLoggedIn();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.adminLoggedIn !== this.props.adminLoggedIn && !this.props.adminLoggedIn && !AdminAuth.isAdminAuthenticated()) {
            this.props.history.push("/admin");
        }
        if (prevProps.productReducer !== this.props.productReducer) {
            const ip4 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP4";
            });
            const ip5mva = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5 MVA";
            });
            const ip7 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP7";
            });
            const ip5 = this.props.productReducer.productsData.find((element) => {
                return element.key === "IP5";
            });
            const ai = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER";
            });
            const aiadvisory = this.props.productReducer.rilaData.find((element) => {
                return element.key === "INDEX ACHIEVER ADVISORY";
            });
            this.setState({
                ip4_gaig: ip4.userGroupGaig,
                ip5mva_gaig: ip5mva.userGroupGaig,
                ip7_gaig: ip7.userGroupGaig,
                ip5_gaig: ip5.userGroupGaig,
                ia_gaig: ai.userGroupGaig,
                iaadvisory_gaig: aiadvisory.userGroupGaig,
                ip4_raymond_james: ip4.userGroupRJ,
                ip5mva_raymond_james: ip5mva.userGroupRJ,
                ip7_raymond_james: ip7.userGroupRJ,
                ip5_raymond_james: ip5.userGroupRJ,
                ia_raymond_james: ai.userGroupRJ,
                iaadvisory_raymond_james: aiadvisory.userGroupRJ,
                ip4_wells_fargo: ip4.userGroupWellsFargo,
                ip5mva_wells_fargo: ip5mva.userGroupWellsFargo,
                ip7_wells_fargo: ip7.userGroupWellsFargo,
                ip5_wells_fargo: ip5.userGroupWellsFargo,
                ia_wells_fargo: ai.userGroupWellsFargo,
                iaadvisory_wells_fargo: aiadvisory.userGroupWellsFargo,
                ip4_mmfa: ip4.userGroupMmfa,
                ip5mva_mmfa: ip5mva.userGroupMmfa,
                ip7_mmfa: ip7.userGroupMmfa,
                ip5_mmfa: ip5.userGroupMmfa,
                ia_mmfa: ai.userGroupMmfa,
                iaadvisory_mmfa: aiadvisory.userGroupMmfa
            });
        }
    }

    logout() {
        this.props.adminLogOut();
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: !this.state[name] });
    }

    validate() {
        let valid = true;
        if(!(this.state.ip4_gaig || this.state.ip5mva_gaig || this.state.ip7_gaig || this.state.ip5_gaig || this.state.ia_gaig || this.state.iaadvisory_gaig)) {
            valid = false;
        }
        if(!(this.state.ip4_raymond_james || this.state.ip5mva_raymond_james || this.state.ip7_raymond_james || this.state.ip5_raymond_james || this.state.ia_raymond_james || this.state.iaadvisory_raymond_james)) {
            valid = false;
        }
        if(!(this.state.ip4_wells_fargo || this.state.ip5mva_wells_fargo || this.state.ip7_wells_fargo || this.state.ip5_wells_fargo || this.state.ia_wells_fargo || this.state.iaadvisory_wells_fargo)) {
            valid = false;
        }
        if(!(this.state.ip4_mmfa || this.state.ip5mva_mmfa || this.state.ip7_mmfa || this.state.ip5_mmfa || this.state.ia_mmfa || this.state.iaadvisory_mmfa)) {
            valid = false;
        }

        this.setState({ adminConfigurationValidateFailed: !valid });
        return valid;
    }

    handleSubmit() {
        this.props.adminPageSetSaved(false);
        if(this.validate()) {
            this.props.adminPageSetSaved(false);
            this.setState({submitted: true});
            this.props.updateProducts(
                this.state.ip4_gaig,
                this.state.ip4_raymond_james,
                this.state.ip4_wells_fargo,
                this.state.ip4_mmfa,
                this.state.ip5mva_gaig,
                this.state.ip5mva_raymond_james,
                this.state.ip5mva_wells_fargo,
                this.state.ip5mva_mmfa,
                this.state.ip7_gaig,
                this.state.ip7_raymond_james,
                this.state.ip7_wells_fargo,
                this.state.ip7_mmfa,
                this.state.ip5_gaig,
                this.state.ip5_raymond_james,
                this.state.ip5_wells_fargo,
                this.state.ip5_mmfa,
                this.state.ia_gaig,
                this.state.ia_raymond_james,
                this.state.ia_wells_fargo,
                this.state.ia_mmfa,
                this.state.iaadvisory_gaig,
                this.state.iaadvisory_raymond_james,
                this.state.iaadvisory_wells_fargo,
                this.state.iaadvisory_mmfa
            );
        }
    }

    render() {
        return (
            <div className={classes.AdminProductsPage}>
                <div className={classes.productsContainer}>
                    {AdminAuth.isAdminAuthenticated() && (
                        <div className={classes.logoutButton}>
                            <button onClick={this.logout}>
                                Logout
                            </button>
                        </div>
                    )}
                    <h5>Choose which products are available for each client</h5>
                    <div className={classes.row}>
                        <div className={classes.columnTitle + ' ' + classes.rowTitle}></div>
                        <div className={classes.column}>IP4</div>
                        <div className={classes.column}>IP5 MVA</div>
                        <div className={classes.column}>IP7</div>
                        <div className={classes.column}>IP5</div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.columnTitle + ' ' + classes.rowTitle}>RIA</div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip4_gaig"
                                checked={this.state.ip4_gaig}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5mva_gaig"
                                checked={this.state.ip5mva_gaig}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip7_gaig"
                                checked={this.state.ip7_gaig}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5_gaig"
                                checked={this.state.ip5_gaig}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.columnTitle + ' ' + classes.rowTitle}>Raymond James</div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip4_raymond_james"
                                checked={this.state.ip4_raymond_james}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5mva_raymond_james"
                                checked={this.state.ip5mva_raymond_james}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip7_raymond_james"
                                checked={this.state.ip7_raymond_james}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5_raymond_james"
                                checked={this.state.ip5_raymond_james}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.columnTitle + ' ' + classes.rowTitle}>Wells Fargo</div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip4_wells_fargo"
                                checked={this.state.ip4_wells_fargo}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5mva_wells_fargo"
                                checked={this.state.ip5mva_wells_fargo}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip7_wells_fargo"
                                checked={this.state.ip7_wells_fargo}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5_wells_fargo"
                                checked={this.state.ip5_wells_fargo}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.columnTitle + ' ' + classes.rowTitle}>Mass Mutual Financial Advisors</div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip4_mmfa"
                                checked={this.state.ip4_mmfa}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5mva_mmfa"
                                checked={this.state.ip5mva_mmfa}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip7_mmfa"
                                checked={this.state.ip7_mmfa}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className={classes.column}>
                            <input
                                className={classes.checkboxRound}
                                type="checkbox"
                                name="ip5_mmfa"
                                checked={this.state.ip5_mmfa}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
                {this.props.adminConfigurationSaved && (
                    <div className={classes.successMessage}>
                        <p>Configuration saved successfully!</p>
                    </div>
                )}
                {this.state.adminConfigurationValidateFailed && (
                    <div className={classes.validateFailed}>
                        <p>Please select a product for the calculator in each row!</p>
                    </div>
                )}
                <div className={classes.row + ' ' + classes.buttonContainer}>
                    <button className={classes.button + ' ' + classes.SaveButton} onClick={this.handleSubmit}>SAVE</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        productReducer: state.productReducer,
        adminLoggedIn: state.admin.adminLoggedIn,
        adminConfigurationSaved: state.admin.adminConfigurationSaved
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenuState: () => dispatch({ type: actionTypes.ADMIN_PAGE }),
        setAdminPage: () => dispatch({
            type: actionTypes.SET_ADMIN_PAGE
        }),
        getAdminProductsConfiguration: () => dispatch(actionCreators.getAdminProductsConfiguration()),
        updateProducts: (
            ip4_userGroupGaig,
            ip4_userGroupRJ,
            ip4_userGroupWellsFargo,
            ip4_userGroupMmfa,
            ip5mva_userGroupGaig,
            ip5mva_userGroupRJ,
            ip5mva_userGroupWellsFargo,
            ip5mva_userGroupMmfa,
            ip7_userGroupGaig,
            ip7_userGroupRJ,
            ip7_userGroupWellsFargo,
            ip7_userGroupMmfa,
            ip5_userGroupGaig,
            ip5_userGroupRJ,
            ip5_userGroupWellsFargo,
            ip5_userGroupMmfa,
            ia_userGroupGaig,
            ia_userGroupRJ,
            ia_userGroupWellsFargo,
            ia_userGroupMmfa,
            iaadvisory_userGroupGaig,
            iaadvisory_userGroupRJ,
            iaadvisory_userGroupWellsFargo,
            iaadvisory_userGroupMmfa
        ) => dispatch(actionCreators.updateProducts(
            ip4_userGroupGaig,
            ip4_userGroupRJ,
            ip4_userGroupWellsFargo,
            ip4_userGroupMmfa,
            ip5mva_userGroupGaig,
            ip5mva_userGroupRJ,
            ip5mva_userGroupWellsFargo,
            ip5mva_userGroupMmfa,
            ip7_userGroupGaig,
            ip7_userGroupRJ,
            ip7_userGroupWellsFargo,
            ip7_userGroupMmfa,
            ip5_userGroupGaig,
            ip5_userGroupRJ,
            ip5_userGroupWellsFargo,
            ip5_userGroupMmfa,
            ia_userGroupGaig,
            ia_userGroupRJ,
            ia_userGroupWellsFargo,
            ia_userGroupMmfa,
            iaadvisory_userGroupGaig,
            iaadvisory_userGroupRJ,
            iaadvisory_userGroupWellsFargo,
            iaadvisory_userGroupMmfa
        )),
        adminLogOut: () => dispatch(actionCreators.adminLogOut()),
        adminSuccessfullyLoggedIn: () => dispatch({ type: actionTypes.ADMIN_SUCCESSFULY_LOGGED_IN }),
        adminPageSetSaved: (value) => dispatch({ type: actionTypes.ADMIN_PAGE_SET_SAVED, value: value })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminProductsPage);


// WEBPACK FOOTER //
// ./src/containers/Admin/AdminProductsPage/AdminProductsPage.js